function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
        return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
        return uri + separator + key + "=" + value;
    }
}
//look for all blog links in the page content and check if AMP Personalization is on, then add to any blog link the following parameter (partner = amp)
$(window).on('load', function () {
    var bloglink = $('#BlogLink').val();
    var ampCookie = getCookie("ameriprise");
    if (ampCookie != "")
    {
        var partner = "ampadvisor";
        if (ampCookie.includes("aficlient")) {
            partner = "ampclient";
        }
        $('a[href*="'+bloglink+'"]').each(function () {
            var elementHref = $(this).attr('href');
            var updated = updateQueryStringParameter(elementHref, "partner", partner);
            $(this).attr('href',updated);
        });
        $('.rTapNumber391857').each(function () {
            $(this).removeClass("rTapNumber391857");
        });
    }
});






